<template>
  <div id="app">
    <top-menu v-on:clicked="menuClicked"></top-menu>
    <router-view v-on:clicked="menuClicked"/>
    <bottom-footer v-on:clicked="menuClicked"></bottom-footer>
  </div>
</template>

<script>

import TopMenu from './components/TopMenu'
import BottomFooter from './components/BottomFooter'

export default {
  name: 'App',
  data: function() {
    return {
      aaa: ''
    }
  },
  components: {
    TopMenu,
    BottomFooter
  },
  methods: {
    menuClicked : function (title) {
      console.log("## ddd " + title)
      //this.$router.push({name: 'HelloWorld'})

      if(title == 'main-home') this.$router.push({name: 'Home'})
      else if(title=='service') {
        this.$router.push({name: 'Service'})
      } else if(title=='service-about') {
        this.$router.push({name: 'Service'})
      } else if(title == 'service-business'){
        this.$router.push({name: 'Service'})
      } else if(title == 'service-history'){
        this.$router.push({name: 'Service'})
      } else if(title == 'portfolio') {
        this.$router.push({name: 'Portfolio'})
      } else if(title == 'blog') {
        this.$router.push({name: 'Blog'})
      } else if(title == 'blog1') {
        this.$router.push({name: 'Blog1'})
      }else if(title == 'blog2') {
        this.$router.push({name: 'Blog2'})
      }else if(title == 'blog3') {
        this.$router.push({name: 'Blog3'})
      } else if(title == 'contact') {
        this.$router.push({name: 'Contact'})
      }
      else this.$router.push({name: 'HelloWorld'})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue